import Axios from '@/axios';

// 查询所有时间配置
export const getAllTimeConfig = params => {  
  return Axios({
    url: '/face/web/duration/show_durations',
    method: 'GET',
    type: 'json',
    params
  })
}
// 查询某个门禁设备的时间配置
export const getDeviceTimeConfigIds = id => {  
  return Axios({
    url: '/face/web/duration/show_device_durations/' + id,
    method: 'GET',
    type: 'json'
  })
}

// 设置某个门禁设备的时间配置
export const setDeviceTimeConfig = data => {  
  return Axios({
    url: '/face/web/duration/device_update_duration',
    method: 'POST',
    type: 'json',
    data
  })
}

// 获取某个配置授权的设备
export const getDevicesByTimeConfig = id => {
  return Axios({
    url: '/face/web/duration/show_duration_list/' + id,
    method: 'GET',
    type: 'json'
  })
}

// 新增时间配置
export const createTimeConfig = data => {  
  return Axios({
    url: '/face/web/duration/create_duration',
    method: 'POST',
    type: 'json',
    data
  })
}
// 修改时间配置
export const modifyTimeConfig = data => {  
  return Axios({
    url: '/face/web/duration/update_duration/' + data.id,
    method: 'POST',
    type: 'json',
    data
  })
}
// 修改时间配置启用状态
export const modifyTimeConfigState = data => {  
  return Axios({
    url: '/face/web/duration/duration_change_state/' + data.id,
    method: 'POST',
    type: 'json',
    data
  })
}
// 删除门禁有效时间
export const deleteTimeConfig = id => {  
  return Axios({
    url: '/face/web/duration/delete_duration/' + id,
    method: 'POST',
    type: 'json'
  })
}

// 获取设备树
export const getDevicesTree = id => {
  return Axios({
    url: '/face/web/duration/show_duration_tree/' + id,
    method: 'GET',
    type: 'json'
  })
}

// 时间配置授权设备
export const setTimeConfigAuth = data => {  
  return Axios({
    url: '/face/web/duration/duration_update_device',
    method: 'POST',
    type: 'json',
    data
  })
}